import { Bot, Globe, Sparkles, Terminal, type LucideIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { clientLabel, cn } from "@/lib/utils";

function iconFor(client: string | null | undefined): LucideIcon {
  const c = (client ?? "").toLowerCase();
  if (c === "web") return Globe;
  if (c.includes("claude-code") || c.includes("claude code")) return Terminal;
  if (c.includes("claude")) return Sparkles;
  return Bot;
}

export function ClientBadge({
  client,
  name,
  className,
}: {
  client: string | null | undefined;
  /** Display name when known (threads carry clientName). */
  name?: string | null;
  className?: string;
}) {
  const Icon = iconFor(client ?? name);
  const label = name || clientLabel(client);
  return (
    <Badge variant="outline" className={cn("gap-1 font-normal", className)} title={client ?? undefined}>
      <Icon aria-hidden />
      <span className="max-w-36 truncate">{label}</span>
    </Badge>
  );
}
